<template>
    <isc-popover
        ref="dropdown"
        placement="bottom"
        :visible-arrow="false"
        :popper-class="$style.popper"
        trigger="hover"
        @show="onShow"
        @hide="active = false"
    >
        <header-action slot="reference" :active="active">应用</header-action>
        <isc-scrollbar ref="scrollbar" :wrap-style="{ maxHeight: '60vh' }">
            <dl v-for="menu in menus" :key="menu.surName">
                <dt>{{ menu.surName }}</dt>
                <dd
                    v-for="app in menu.apps"
                    :key="app.id"
                    draggable="true"
                    unselectable="on"
                    @drag="(ev) => onDragging(ev, app)"
                    @dragend="onDragend"
                    @click="openApp(app)"
                >
                    {{ app.name }}
                </dd>
            </dl>
        </isc-scrollbar>
    </isc-popover>
</template>

<script>
import HeaderAction from '@/components/desk-header/header-action';
import { eventBus } from '@/plugins/event-bus';
import { AppInMenuType } from '../../types/desk';

export default {
    name: 'HeaderApps',
    components: { HeaderAction },
    data() {
        return {
            active: false
        };
    },

    computed: {
        menus() {
            /**
             * @type {DeskApp[]}
             */
            const allowedApps = this.$store.state.desk.allowedApps;
            const surNameSet = new Set();
            const surNameObj = {};

            allowedApps.forEach((app) => {
                const { surName, inMenu, name, id } = app;

                if (inMenu !== AppInMenuType.DISPLAY) return;

                surNameSet.add(surName);
                surNameObj[surName] = surNameObj[surName] || [];
                surNameObj[surName].push(app);
            });

            /**
             * @type {{surName: string; apps: DeskApp[]}[]}
             */
            const menus = [];

            surNameSet.forEach((surName) => {
                const apps = surNameObj[surName];
                menus.push({
                    surName,
                    apps
                });
            });

            return menus;
        }
    },

    methods: {
        onShow() {
            this.active = true;
            this.$store.dispatch('desk/getAllowedApps');
        },

        onDragging(ev, val) {
            eventBus.$emit('drag', [ev, val]);
        },

        onDragend(ev) {
            eventBus.$emit('dragend', ev);
        },

        openApp(app) {
            this.$appManager.openApp(app.code);
        }
    }
};
</script>

<style lang="scss" module>
.popper {
    border: 0 !important;
    background: #24252c !important;
    width: 210px;
    border-radius: 4px !important;
    padding: 0 !important;

    :global {
        .isc-scrollbar__thumb {
            background: #999;
        }
    }

    dl {
        margin-top: 10px;
        margin-bottom: 10px;
    }

    dt {
        font-size: 12px;
        color: #aaa;
        line-height: 20px;
        padding: 0 12px;
    }

    dd {
        color: #fff;
        font-size: 14px;
        line-height: 38px;
        cursor: pointer;
        padding: 0 12px;

        &:hover {
            background: #3a3a3a;
        }
    }
}
</style>
